import { render, staticRenderFns } from "./modalDuplicar.vue?vue&type=template&id=81f37e3c&"
import script from "./modalDuplicar.vue?vue&type=script&lang=js&"
export * from "./modalDuplicar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports